<template>
  <EditCom
    :target="addTarget"
    :inputList="addInputList"
    :buttonList="addButtonList"
    :rules="addRules"
    :title="title"
    @closeFun="closeAdd"
    ref="edit_com"
  />
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue';
import EditCom from '@/components/EditCom/index.vue'
import { message } from '@/utils/js/initVariable'
import { dayjs } from  '@/utils/js/initVariable';

import {
  addTask,
} from '@/api/UserWorkspaceApi';

const props = defineProps({
  target: {
    type: Object,
    default: () => ({})
  },
  title: {
    type: String,
    default: () => ({})
  }
})

const closeAdd = ()=>{
  emit('close')
}

const addSubmit = (form, target, button, loadFn) => {
  // console.log(form, target, button, loadFn);
  form.value.validate((valid) => {
    if (valid) {
      // 构造请求参数（只保留图层相关字段）
      addTask({
        ...target,
        firstExecuteTime: dayjs(target['firstExecuteTime']).format('YYYY-MM-DD HH:mm:ss'),
      }).then((res) => {
        if (res.data.code === 1004) {
          message(`上传成功`, 1)
          closeAdd()
          emit('refresh')
        }
      }).catch((err) => {
        console.error(err)
        message('请求失败', 0)
      }).finally(() => {
        loadFn() 
      })
    } else {
      loadFn() 
    }
  })
}
// 组件EditCom
const addTarget = reactive({
  ...props.target,
  spanTypeList: [
    { value: 'DAY', label: '日', },
    { value: 'WEEK', label: '周', },
    { value: 'NOW_WEEK', label: '当周（预发布）', },
    { value: 'MONTH', label: '月', },
  ]
})

const addInputList = ref([
  { name: '任务名称', prop: 'taskName', type: 'text' },
  { name: '任务描述', prop: 'taskDesc', type: 'textarea', },
  { name: '任务类型', prop: 'spanType', type: 'select',
    select: {
      list: 'spanTypeList',
      value: 'value',
      label: 'label',
    }
  },
  { name: '首次执行时间', prop: 'firstExecuteTime', type: 'datetime',
    date: { }
  },
  { name: '执行次数', prop: 'executeCount', type: 'number',
    number: { min: -1, },
    message: { text: '"-1"为无限次执行', },
  },
]),
addButtonList = ref([
  { name: '取消', fun: closeAdd, type: 'danger', },
  { name: '确定', fun: addSubmit, type: 'primary', },
]),
addRules = reactive({
  taskName: [
    { required: true, message: '请输入任务名称', trigger: 'blur' },
  ],
  spanType: [
    { required: true, message: '请选择任务类型', trigger: 'blur' },
  ],
  firstExecuteTime: [
    { required: true, message: '请选择首次执行时间', trigger: 'blur' },
  ],
  executeCount: [
    { required: true, message: '请输入执行次数', trigger: 'blur', },
  ],
})
const form = ref({
})

const formRef = ref(null)

const eventTypes = ref([])

const emit = defineEmits(['close', 'confirm', 'refresh'])

const editFlag = ref(false)

const close = () => {
  emit('close')
}

onMounted(() => {
  
})
</script>

<style lang="less" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.additional-info {
  margin-top: 16px;
}
</style>